import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import Loader from "../../components/Common/Loader";
import CommonWorkoutPlan from "../Client/CommonWorkoutPlan";
import { fetchWorkoutPlanThunk } from "../../redux/Slices/workoutPlanSlice";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import WorkoutPlaceholder from "../../styles/Assets/workout_placeholder.jpg";

const { Panel } = Collapse;

const AIAssistanceExistingWorkoutPlanModal = ({
  showModal,
  setShowModal,
  workoutPlanList,
  modalLoading,
}) => {
  const dispatch = useDispatch();
  const { trans } = useCustomTranslation();
  const [activeKey, setActiveKey] = useState(null);
  const [toggleSelected, setToggleSelected] = useState(false);

  const { workoutPlan } = useSelector((state) => state?.getWorkoutPlan);

  const handlePanelChange = (key) => {
    if (activeKey === key) {
      setActiveKey(null);
      setToggleSelected(false);
    } else {
      setActiveKey(key);
    }
  };

  const handleArrowClick = (e, key, planId, clientId) => {
    dispatch(
      fetchWorkoutPlanThunk({
        clientId: workoutPlanList.clientId,
        coachId: workoutPlanList.coachId,
        coachWorkoutPlanId: planId,
      })
    );
    setToggleSelected(!toggleSelected);
    e.stopPropagation();
    handlePanelChange(key);
  };

  if (!showModal) return null;

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target.className === "modal-overlay") setShowModal(false);
      }}
    >
      <div
        className={`modal-content ${
          modalLoading ? "modal-content-loading" : ""
        }`}
      >
        <div className="modal-header">
          <h4>Workout Plan Details</h4>
          <button
            className="modal-close"
            onClick={() => setShowModal(false)}
            disabled={modalLoading}
          >
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="ai-modal-body">
          {modalLoading ? (
            <Loader />
          ) : (
            <>
              {workoutPlanList?.workoutPlans?.length > 0 ? (
                <Collapse collapsible={false} activeKey={activeKey} accordion>
                  {workoutPlanList?.workoutPlans?.map((item) => (
                    <Panel
                      className="Panel-workout-accordion"
                      key={item?.workoutPlanId}
                      header={
                        <div className="collapse-header-workoutplan d-flex align-items-center">
                          <img
                            src={item?.imageUrl || WorkoutPlaceholder}
                            alt="Workout Plan"
                            className="excer-image mr-2"
                          />

                          <span className="workout-plan-plan">
                            {item?.name}
                          </span>

                          <div className="session-count">
                            <span></span>
                          </div>
                          <DownOutlined
                            className="down-arrow-accordion"
                            onClick={(e) => {
                              handleArrowClick(
                                e,
                                item.workoutPlanId,
                                item.workoutPlanId,
                                item.clientId
                              );
                            }}
                          />
                        </div>
                      }
                      showArrow={false}
                    >
                      <CommonWorkoutPlan workoutPlan={workoutPlan} />
                    </Panel>
                  ))}
                </Collapse>
              ) : (
                <div className="middle-text-noplan">
                  {trans("ClientWorkout.noWorkoutPlan")}
                </div>
              )}
            </>
          )}
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowModal(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIAssistanceExistingWorkoutPlanModal;
